import React, { useEffect, useRef, useState } from 'react';
import { Divider, Text, VStack } from '@adc/parallax-component-library';
import { Button } from 'Components/utility';
import { checkBrowser } from 'Utilities/browser';
const { isAndroid } = checkBrowser();
const Footer = (props) => {
    const footerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        // This prevents the footer from moving to the top of screen when the keyboard opens on Android
        if (footerRef.current && isAndroid) {
            const sumedges = window.innerWidth + window.innerHeight;
            const handleResize = () => {
                const keyboardIsOpen = window.innerWidth + window.innerHeight < sumedges;
                setIsVisible(!keyboardIsOpen);
            };
            window.visualViewport?.addEventListener('resize', handleResize);
            return () => {
                window.visualViewport?.removeEventListener('resize', handleResize);
            };
        }
    }, []);
    if (!isVisible) {
        return null;
    }
    if (props.children) {
        const { children, padding } = props;
        return (React.createElement(VStack, { padding: padding, width: "100%", ref: footerRef }, children));
    }
    const { padding, buttonLabel, buttonTestID, onButtonPress, disabled, onSecondaryButtonPress, secondarySectionLabel, secondaryButtonTestID, secondaryButtonLabel, } = props;
    const hasSecondarySetup = onSecondaryButtonPress &&
        secondaryButtonLabel &&
        secondarySectionLabel &&
        secondaryButtonTestID;
    return (React.createElement(VStack, { padding: padding, width: "100%", ref: footerRef },
        React.createElement(Button, { onPress: () => onButtonPress?.(), testID: buttonTestID, disabled: disabled, "aria-label": buttonLabel, label: buttonLabel }),
        hasSecondarySetup && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { marginTop: "$6", marginBottom: "$4", borderColor: "$neutral.40" }),
            React.createElement(VStack, { alignItems: "center" },
                React.createElement(Text, { type: "$bodySmall.default", testID: `${secondaryButtonTestID}-title`, nativeID: `${secondaryButtonTestID}-title` }, secondarySectionLabel),
                React.createElement(Button, { variant: "tertiary", label: secondaryButtonLabel, onPress: onSecondaryButtonPress, testID: secondaryButtonTestID }))))));
};
export { Footer };
